import { useCallback, useState } from 'react';

export interface JustificativaSugerida {
  /** Texto atual do campo (a sugestão, ou o que a pessoa escreveu). */
  texto: string;
  /** true quando a pessoa alterou o texto: a partir daí a sugestão não sobrescreve mais o que ela escreveu. */
  editada: boolean;
  /** Chamar no onChange do campo. */
  editar: (valor: string) => void;
  /** Volta ao texto sugerido (também usado para reiniciar o campo ao abrir um formulário). */
  restaurar: () => void;
}

/**
 * Campo de Justificativa SOX pré-preenchido. Enquanto a pessoa não mexer no texto, ele é a própria sugestão
 * (que muda conforme grupo, contas, empresas etc. escolhidos) — derivada a cada render, sem efeito e sem
 * valor defasado. Ao editar, o texto dela é preservado; se ela digitar exatamente a sugestão, volta a acompanhá-la.
 */
export const useJustificativaSugerida = (sugestao: string): JustificativaSugerida => {
  const [editado, setEditado] = useState<string | null>(null);

  const editar = useCallback((valor: string) => {
    setEditado(valor !== sugestao ? valor : null);
  }, [sugestao]);

  const restaurar = useCallback(() => setEditado(null), []);

  return { texto: editado ?? sugestao, editada: editado !== null, editar, restaurar };
};
